<template>
  <div class="product-list">
   <!--搜索表单-->
   <div class="common-seach-wrap">
 
     <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
       
      <el-form-item label="选择取货点">
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">选择取货点</el-button>
        </el-row>
      </el-form-item>
      
  
       <el-form-item label="申请时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="searchForm.year" type="year"
             value-format="yyyy" ></el-date-picker>
          </div>
        </el-form-item>

       <el-form-item>
         <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
       
       </el-form-item>
     </el-form>
   </div>
 
   <div class="common-seach-wrap" >
 
    <el-form size="small" ref="setting" :model="setting" label-width="80px" >
      <el-form-item label="取货满多少" >
        <el-input v-model="setting.store_m_money" type="number" class="max-w460"></el-input>元
      </el-form-item>


      <el-form-item label="店补奖励">
        <el-input v-model="setting.store_money" type="number" class="max-w460"></el-input>%
        <div class="tips">积分的10%，A商品100元，积分50，当取货业绩超过{{setting.store_m_money}}元，获得积分的10%作为佣金奖励</div>
      </el-form-item>

      <el-form-item>
         <el-button size="small" type="primary" icon="el-icon" @click="submit">提交</el-button>
       
       </el-form-item>

    </el-form>

   </div>

   <!--内容-->
   <div class="tips" style="color: red;">以下只计算订单完成的业绩</div>
   <div class="product-content" style="margin-top: 20px;">
     <div class="table-wrap">
       <el-table size="small" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange" v-loading="loading"   >
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column prop="ind" label="月份" width="80"></el-table-column>
        <el-table-column prop="store_name" label="取货点"></el-table-column>
         <el-table-column prop="user.user_id" label="用户ID"></el-table-column>
         <el-table-column prop="user.nickName" label="用户"></el-table-column>
         <el-table-column prop="user.mobile" label="联系方式"></el-table-column>
        <el-table-column prop="achievements" label="业绩"></el-table-column>
        <el-table-column prop="points" label="店补积分"></el-table-column>
        <el-table-column prop="fprice" label="返利金额"></el-table-column>
        <el-table-column prop="points" label="是否达到条件">
          <template slot-scope="scope">
              <div class="name" style="font-weight: 600;font-size: 16px;">
                <p v-if="setting.store_m_money < scope.row.achievements && scope.row.achievements != 0">
                  已达到</p>
                <p v-else>
                  未达到
                </p>
               </div>
           </template>

        </el-table-column>

        <el-table-column prop="is_settled" label="是否结算"  width="200">
          <template slot-scope="scope">
              <div class="name" style="font-weight: 600;font-size: 16px;">
                  <el-radio-group  v-model="scope.row.is_settled">
                      <el-radio  :label="1" @change="setVal(1,scope.row)">结算</el-radio>
                      <el-radio  :label="2" @change="setVal(2,scope.row)">未结算</el-radio>
                  </el-radio-group>
              </div>
          </template>
        </el-table-column>


         
       </el-table>
     </div>
   </div>


        <!--添加-->
        <Store :is_open="open_add"  @closex="closeDialogFunc" :multi="multi"></Store>


 </div>
</template>

<script>
 import StatisticsApi from '@/api/statistics.js';
 import Store from '@/components/store/Store.vue';
 import qs from 'qs';
 export default{
   components:{
    Store
   },
   data(){
     return{
       /*是否正在加载*/
       activeName: 'type7',
       loading: true,
       tableData:[],
       /*一页多少条*/
       pageSize: 20,
       /*一共多少条数据*/
       totalDataNumber: 0,
       /*当前是第几页*/
       curPage: 1,
       /*搜索参数*/
       searchForm: {
         user_search: '',
         supply_search:"",
         year:"",
         store_id:0,
       },
       setting:{
        store_money:0,
        store_m_money:0,
       },
       /*数据对象*/
       dataModel:{},
       /*选中的*/
      multipleSelection: [],
      multi:false,
      open_add:false,


     }
   },
   provide: function () {
     return {
       dataModel: this.dataModel
     }
   },
   created() {

     this.getData();
     this.getSetting();
   },
   methods:{
    setVal (ind,row) {
      let self = this;
      let Params = {
        'code':'dianbu',
        'ind':ind,
        'row':row,
      };
      StatisticsApi.setSettled(Params, true)
        .then(data => {
          self.loading = false;
          self.getData();
          
        })
        .catch(error => {});
    },  

    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      StatisticsApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          self.setting = data.data.vars.values;
          
        })
        .catch(error => {});
    },
    /*点击保存*/
    submit() {
      let self = this;
      let params = self.setting;
      self.loading = true;
      StatisticsApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
      /*打开添加*/
      addClick(item) {
        this.open_add = true;
      },
          /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (e.type != 'error') {
          this.searchForm.store_id = e.params.store_id;
        }
        this.open_add = false;
        this.getData();
    },


     /*选择第几页*/
     handleCurrentChange(val) {
       let self = this;
       self.loading = true;
       self.curPage = val;
       self.getData();
     },

     /*每页多少条*/
     handleSizeChange(val) {
       this.pageSize = val;
       this.getData();
     },
      /*选择数据*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },


     /*搜索查询*/
     onSubmit() {
       this.curPage = 1;
       this.getData();
     },

     /*获取数据*/
     getData() {
       let self = this;
       let Params = self.searchForm;
       Params.limit =JSON.stringify({
        "page":self.curPage,
        "list_rows": self.pageSize
       }) 
       Params.type = self.activeName;
       self.loading = true;
       StatisticsApi.getDianbu(Params, true)
         .then(res => {
           self.tableData = res.data.list;
          //  self.cond = res.data.cond;
           self.loading = false;
         })
         .catch(error => {});
     },
     batchExport(){//批量导出
        // 勾选需要导出的数据
        let ids = [];
      let params = this.multipleSelection;
      console.log("params",params)
      params.forEach((param)=>{
        ids.push(param.user_id);
      })
      ids = ids.join(',');
      // 筛选条件
      // 商品状态
      var parmasa =  this.searchForm?this.searchForm:{};
      console.log("parmasa",parmasa)
      parmasa["list_rows"] = this.pageSize
      parmasa["page"] = this.curPage
      if(ids.length > 0){
        // console.log(this.searchForm)
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/product.product/exportUsercommission?' + 
        qs.stringify(parmasa)+'&ids='+ids;
        
      }else{
        this.$message({
            message: '请选择要导出的数据',
            type: 'error'
          });
      }
   

    },

   }
 }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/statistics/dianbu/index.vue